var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"filterbutton",on:{"click":_vm.clickHandler}},[_vm._v("\n            Filtros\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }